import React from 'react'
import { toAbsoluteUrl } from '../../Utils/_helpers';
import { useState } from "react";

const DisclaimerText = ({ className, message }) => {
    const [isVisible, setIsVisible] = useState(true);

    const toggle = () => {
        setIsVisible(!isVisible);
    };

    return (
        <>
            {isVisible && <div className="highlighted-disclamer-text">
                <span className={className}>
                    <img
                        alt=""
                        src={toAbsoluteUrl('/media/sr/icons/warning-red.svg')}
                        style={{ marginRight: '10px' }}
                        height={24}
                    />
                    <span>{message}</span>
                </span>
                <img
                    alt=""
                    src={toAbsoluteUrl('/media/sr/icons/close.svg')}
                    style={{ marginRight: '10px', position: 'absolute', right: '0px', cursor: 'pointer' }}
                    height={20}
                    onClick={toggle}
                />
            </div>}
        </>
    );
};

export default DisclaimerText